import { render, staticRenderFns } from "./BillingTypeSelector.vue?vue&type=template&id=15f4beee&scoped=true&"
import script from "./BillingTypeSelector.vue?vue&type=script&lang=ts&"
export * from "./BillingTypeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./BillingTypeSelector.vue?vue&type=style&index=0&id=15f4beee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f4beee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
